import React from 'react';

function clientRandomizer(props) {
  const millsAds = [
    {
      image: '/tosca-2022/sponsors/pbs.jpg',
      link: 'https://www.pbsutah.org',
      alt: 'PBS Utah',
      class: 'webFormat',
    },
    {
      image: '/tosca-2022/sponsors/classical-89.jpg',
      link: 'https://www.classical89.org',
      alt: 'Classical 89',
      class: 'webFormat',
    },
    {
      image: '/tosca-2022/sponsors/donation-ad.jpg',
      link: 'https://www.usuo.org/give',
      alt: 'Donatio to USUO today',
      class: 'webFormat',
    },
    {
      image: '/tosca-2022/sponsors/EBT-Ad.jpg',
      link: 'http://new.everybloomingthing.cc/',
      alt: 'Every Blooming Thing',
      class: 'webFormat',
    },
    {
      image: '/tosca-2022/sponsors/ghost-light.jpg',
      link: 'https://utahsymphony.org/media/ghost-tosca-podcast/',
      alt: 'USUO Ghostlight Podcast',
      class: 'webFormat',
    },
    {
      image: '/tosca-2022/sponsors/penzance.jpg',
      link: 'https://utahopera.org/',
      alt: 'Pirates of Penzance Utah Opera',
      class: 'webFormat',
    },
    {
      image: '/tosca-2022/sponsors/homewood.jpg',
      link: 'https://www.hilton.com/en/hotels/slchwhw-homewood-suites-salt-lake-city-downtown/',
      alt: 'Homewood Suites',
      class: 'webFormat',
    },
    {
      image: '/tosca-2022/sponsors/uo-schools.jpg',
      link: 'https://www.utahopera.org/',
      alt: 'Homewood Suites',
      class: 'webFormat',
    },
    {
      image: '/tosca-2022/sponsors/prelude-lectures.jpg',
      link: 'https://www.utahopera.org',
      alt: 'Prelude Opera Lectures',
      class: 'webFormat',
    },
    {
      image: '/tosca-2022/sponsors/residence-inn.jpg',
      link: 'https://www.marriott.com/search/findHotels.mi',
      alt: 'Residence Inn',
      class: 'webFormat',
    },
    {
      image: '/tosca-2022/sponsors/utah-food-services.jpg',
      link: 'https://utahfoodservices.com/',
      alt: 'Utah Opera Resident Artists',
      class: 'webFormat',
    },
  ];

  const randomAd = millsAds[Math.floor(Math.random() * millsAds.length)];

  return (
    <>
      <hr />
      <br />
      <a href={randomAd.link} target="_blank" rel="noopener noreferrer">
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </a>
      <br />
      <br />
      <hr />
    </>
  );
}

export default clientRandomizer;
